<template>
  <div class="hs-container">
    <div class="header-box" :style="{opacity: showFixedHeader ? 1 : 0}">
      <hs-tab-4
          v-if="hasPower('因公') && hasPower('因私')"
          :options="busOptions"
          height="48px"
          :selectedIndex="selectedIndex"
          @select="_selectTab"
      />
      <!-- 仅有因公 或 因私 默认写死展示 -->
      <hs-tab-4
          v-else-if="hasPower('因公') || hasPower('因私')"
          height="48px"
          :options="hasPower('因公') ? [$t('BusinessTrip')] : [$t('PersonalTrip')]"
          :selectedIndex="0"
      />
    </div>
    <hs-scroll
      ref="tableView"
      class="table-view"
      :data="[details]"
      :options="tableViewOptions"
      @pulling-down="_reloadWebview"
      :isListenScroll="true"
      @scroll="_mixinScroll"
    >
      <ul class="scroll-content" v-if="hasPower('因公') || hasPower('因私')">
        <hs-tab-4
            v-if="hasPower('因公') && hasPower('因私')"
            :options="busOptions"
            height="48px"
            :selectedIndex="selectedIndex"
            @select="_selectTab"
        />
        <!-- 仅有因公 或 因私 默认写死展示 -->
        <hs-tab-4
            v-else-if="hasPower('因公') || hasPower('因私')"
            height="48px"
            :options="hasPower('因公') ? [$t('BusinessTrip')] : [$t('PersonalTrip')]"
            :selectedIndex="0"
        />

        <div v-if="selectedIndex === 1" style="height: 12px"></div>

        <!-- 欢迎卡 -->
        <home-welcome-card v-if="selectedIndex === 0" :approvalList="approvalList" />

        <current-order
            v-if="unImportantInitInfo && unImportantInitInfo.TravelingCarOrder && unImportantInitInfo.TravelingCarOrder.Id"
            type="new-style"
            style="margin-bottom: 12px"
            :IsShowPay="unImportantInitInfo.TravelingCarOrder.PageBtnInfo &&
             unImportantInitInfo.TravelingCarOrder.PageBtnInfo.IsShowPay && unImportantInitInfo.TravelingCarOrder.PageBtnInfo.PayOperationType === 0"
            :Description="unImportantInitInfo.TravelingCarOrder.Description"
            @viewOrder="_viewCurrentOrder"
        />

        <!-- 机票酒店快捷入口 -->
        <keep-alive>
          <!-- 出差申请单列表 -->
          <home-auth-list v-if="selectedIndex === 0 && showOalist" :list="oalist" />
          <home-business-card
              v-else-if="hasPlaneTicketEntry || hasHotelEntry"
              :TravelType="selectedIndex"
          />
        </keep-alive>

        <!-- home 页业务订单入口 -->
        <home-business-entry v-if="_getBusinessCount() > 0" :count="_getBusinessCount()" :details="details" @gotoPage="_gotoPage" :TravelType="selectedIndex" />

        <!--公告-->
        <div class="home-announcement" v-if="messages && messages.length > 0">
          <div class="bar">
            <van-swipe ref="VanSwipe" style="height: 20px;" autoplay="3000" vertical :show-indicators="false">
              <van-swipe-item v-for="(item, index) in messages" :key="index">
                <div class="news">
                  <span>{{ item.Title }}</span>
                  <div class="announcement-icon" @click="_gotoAnnouncementDetails(item)" >
                    {{$t('ClickToView')}}<img src="@/assets/image/base/cell/icons_12pt_right_1.png"/>
                  </div>
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>
          <div class="announcement-icon">
            {{$t('ClickToView')}}<img src="@/assets/image/base/cell/icons_12pt_right_1.png"/>
          </div>
        </div>

        <!-- banner -->
        <home-banner v-if="banners && banners.length > 0" :banners="banners"  @delegate="_gotoFrame" />

        <!-- 旅游会务需求单 -->
        <div class="travel-form"
             v-if="selectedIndex === 0 && hasPower('因公:旅游会务')"
             :style="{backgroundImage: `url(${require('@/assets/image/home/default_banner.jpg')})`}"
             @click="_gotoTravelForm"></div>
        <div style="width: 100%; height: 15px"></div>
      </ul>
    </hs-scroll>

    <c-tabbar></c-tabbar>

    <!-- 外部页面 -->
    <c-frame
      ref="CFrame"
      :title="frameDetails.Title"
      :url="frameDetails.LinkUrl"
    ></c-frame>

    <!-- oa申请单跳转弹框 -->
    <select-business-book v-if="showOalist" ref="RefsSelectBusinessBook" :list="oaBusinessList" @select="_goToOaBooking" />

    <!-- 控制版本 需要和后端版本信息保持一致 !!!!-->
    <div ref="GetVersion" class="getVersion" :title="VERSION"></div>
  </div>
</template>
<script type="text/ecmascript-6">
import CFrame from 'components/c-frame/c-frame'
import HsScroll from 'base/hs-scroll/hs-scroll'
import CTabbar from 'components/c-tabbar/c-tabbar'
import SelectBusinessBook from './select-business-book'
import HsTab4 from "@/base/hs-tab/hs-tab-4.vue";
import HomeWelcomeCard from "@/pages/home/home/home-welcome-card.vue";
import HomeBusinessCard from "@/pages/home/home/home-business-card.vue";
import HomeBusinessEntry from "@/pages/home/home/home-business-entry.vue";
import HomeBanner from "@/pages/home/home/home-banner.vue";
import HomeAuthList from "@/pages/home/home/home-auth-list.vue";
import {
  kpiHomeLoadInitInfo,
  kpiUserGetUserManageInfo,
} from 'api'
import {kpiAccessGetFoodAddress} from 'api/dinner/dinnerApi'
import {kpiCarGetOperationUrl} from 'api/car/carApi.js'
import {mapMutations, mapState} from 'vuex'
import {DEFAULT_CURRENCY_INFO} from '../../common/constants/common';
import {getRoutePath, hotelRoutePush, planeRoutePush, setHomsomLoginType, trainRoutePush} from "@/common/utility/utils";
export default {
  mounted() {
    // 检查版本号
    this._checkVersion()
    // 获取首页数据
    this._getDetails()
    // 获取审批数据
    this._getUserManageInfo()
    // 初始化selectedIndex
    this._initPersonalPower()
  },
  beforeDestroy() {
    this.timeInterval && clearInterval(this.timeInterval);
    this.oaTimeInterval && clearInterval(this.oaTimeInterval);
  },
  computed: {
    ...mapState([
      'PersonalPower',
      'noticeDetails'
    ]),
    // 是否是微信小程序环境 、微信环境、企业微信环境
    isWeChatApplet() {
      let val = false
      let ua = navigator.userAgent.toLowerCase();
      if (
        window.__wxjs_environment === 'miniprogram' ||
        /MicroMessenger/i.test(ua) ||
        /wxwork/i.test(ua)
      ) {
        // RequestSource = 'WechatMiniProgram'
        val = true
      }
      return val
    },
    isMiniprogram() { // 是否是微信小程序环境
      return this.$store.state.isMiniprogram
    },
    showOalist() { // 有 申请单申请权限 或者 有申请单列表权限 则展示申请单信息
      let showOalist = false
      if (
        this.hasPower('我的:授权码订单') &&
        (
          (this.oalist && this.oalist.length > 0) ||
          (this.details.UnHandleAuthCodeInfoCount && this.details.UnHandleAuthCodeInfoCount > 0)
        )
      ) {
        showOalist = true
      }
      return showOalist
    },
    /** 机票入口 */
    hasPlaneTicketEntry() {
      let val = false
      if (this.selectedIndex === 0 && this.hasPower('因公:机票')) {
        val = this.hasPower('因公:机票:国内机票查询') || this.hasPower('因公:机票:国际机票查询')
      }
      if (this.selectedIndex === 1) {
        val = this.hasPower('因私:国内机票') || this.hasPower('因私:国际机票')
      }
      return val
    },
    /** 酒店入口 */
    hasHotelEntry() {
      let val = false
      if (this.selectedIndex === 0 && this.hasPower('因公:酒店')) {
        val = this.hasPower('因公:酒店:国内酒店查询') || this.hasPower('因公:酒店:国际酒店查询')
      }
      if (this.selectedIndex === 1 && this.hasPower('因私')) {
        val = this.hasPower('因私:国内酒店') || this.hasPower('因私:国际酒店')
      }
      return val
    },
  },
  watch: {
    PersonalPower() {
      this._initPersonalPower()
    }
  },
  data() {
    return {
      busOptions: [this.$t('BusinessTrip'), this.$t('PersonalTrip')],

      tableViewOptions: {
        pullDownRefresh: {
          threshold: 50
        },
        pullUpLoad: false
      },
      details: {},
      banners: [],
      bannerSwiper: undefined,
      version: '',
      selectedIndex: 0,
      // bookActivedIndex: 1, // 读取权限 1: 因公出行 2: 因私出行
      messagesDetails: [],
      messages: [],
      messagesIndex: 0,
      frameDetails: {},
      /** OA */
      oalist: [],
      oaTitle: '',
      oalistIndex: 0,
      /******************/

      oaBusinessList: [], // 点击申请单预订支持的业务列表
      approvalList: [], // 审批列表

      userManageInfo: null,
      unImportantInitInfo: null,

      showFixedHeader: false, // 顶部header固定
    }
  },
  methods: {
    ...mapMutations([
      'SET_USER_MANAGE_INFO',
      'UPDATE_NOTICE_DETAILS',
      'UPDATE_THEME_SETTING',
      'UPDATE_AMAP_KEY',
    ]),
    /**
     * 检查版本号
     */
    _checkVersion() {
      console.log('检查版本号')
      // 6.1.2 版本临时代码
      if (window.localStorage.DOMESTIC_PLANE_CITY) {
        let DOMESTIC_PLANE_CITY = JSON.parse(window.localStorage.DOMESTIC_PLANE_CITY)
        if (!DOMESTIC_PLANE_CITY.version) {
          this._reloadWebview()
        }
      }
      if (window.localStorage.INTL_PLANE_CITY) {
        let INTL_PLANE_CITY = JSON.parse(window.localStorage.INTL_PLANE_CITY)
        if (!INTL_PLANE_CITY.version) {
          this._reloadWebview()
        }
      }
      if (window.localStorage.DOMESTIC_HOTEL_CITY) {
        let DOMESTIC_HOTEL_CITY = JSON.parse(window.localStorage.DOMESTIC_HOTEL_CITY)
        if (!DOMESTIC_HOTEL_CITY.version) {
          this._reloadWebview()
        }
      }
      if (window.localStorage.INTER_HOTEL_CITY) {
        let INTER_HOTEL_CITY = JSON.parse(window.localStorage.INTER_HOTEL_CITY)
        if (!INTER_HOTEL_CITY.version) {
          this._reloadWebview()
        }
      }
      if (window.localStorage.DOMESTIC_TRAIN_CITY) {
        let DOMESTIC_TRAIN_CITY = JSON.parse(window.localStorage.DOMESTIC_TRAIN_CITY)
        if (!DOMESTIC_TRAIN_CITY.version) {
          this._reloadWebview()
        }
      }
      // 6.1.2 版本临时代码 end
    },
    /**
     * 获取首页数据
     */
    _getDetails() {
      this.unImportantInitInfo = null
      kpiHomeLoadInitInfo().then((res) => {
        console.log('首页: ', res)
        let data = res.ResultData
        this._initBaseInfo(data.BasicInfo)
        this._initTodoList(data.ToDoList)
        this._initUnImportantInfo(data.TravelingCarOrder)
        this._initBanners(data.CarouselAds)
        this._initNotices(data.SystemNoticeCollection && data.SystemNoticeCollection.Notices)
        this._initCalendar(data.CalendarInfos)
        this._initOaList(data.UnHandleAuthCodeListResult)
        this._initMessageStatistics(data.MessageStatistics)
        this._initTheme(data.CurrentTheme)
        this._initGaoDeMapKey(data.UnionMessage && data.UnionMessage.MapKey || {})
      }).catch(() => {
        this.$refs.tableView && this.$refs.tableView.forceUpdate();
      })
    },

    // 初始化home页基本信息
    _initBaseInfo(data) {
      this.details = data
      this._saveSearchTips(data.SearchTips)
      window.localStorage.CityVersion = JSON.stringify(this.details.CityVersion)
    },

    // 初始化审批信息
    _initTodoList(data) {
      this.approvalList = data || []
    },

    // 初始化不重要的信息
    _initUnImportantInfo(data) {
      this.unImportantInitInfo = data
    },

    // 初始化banner数据
    _initBanners(list) {
      this.banners = list || []
    },

    // 初始化公告信息
    _initNotices(Notices) {
      this.messagesDetails = Notices || []
      this.messages = Notices || []
    },

    // 初始化日历数据
    _initCalendar(CalendarInfos) {
      window.localStorage.CALENDAR = JSON.stringify(CalendarInfos || [])
    },

    // 初始化oa待处理订单
    _initOaList(data) {
      this.oalist = data.UnHandleAuthCodeInfos || []
      this.oaTitle = data.Title
    },

    // 初始化消息统计数据
    _initMessageStatistics(data) {
      this.UPDATE_NOTICE_DETAILS(data)
    },

    // 初始化主题
    _initTheme(data) {
      this.UPDATE_THEME_SETTING(data)
    },

    // 初始化高德地图key
    _initGaoDeMapKey(data) {
      this.UPDATE_AMAP_KEY({
        key: data.Key,
        securityJsCode: data.Secret,
      })
    },

    _getUserManageInfo() {
      let params = {
        Version: 1
      }
      kpiUserGetUserManageInfo(params, true).then((res) => {
        console.log('管理: ', res)
        this.SET_USER_MANAGE_INFO(res.ResultData)
        this.$refs.tableView && this.$refs.tableView.forceUpdate();
      })
    },

    /** 保存gif loading tips数据 */
    _saveSearchTips(res) {
      window.localStorage.SearchTips = JSON.stringify(res)
    },

    /** 去banner链接 */
    _gotoFrame(index) {
      this.frameDetails = this.banners[index]
      if (
        this.frameDetails.LinkUrl && (
          this.frameDetails.LinkUrl.startsWith('http') ||
          this.frameDetails.LinkUrl.startsWith('https')
        )
      ) {
        if (this.frameDetails.AdBusinessType === 3) { // 旅游会务需求单
          window.location.href = this.frameDetails.LinkUrl
        } else {
          this.$refs.CFrame.open()
        }
      }
    },

    /** 去公告详情 */
    _gotoAnnouncementDetails(item) {
      if (item.NoticeDetailUrl) {
        let url = item.NoticeDetailUrl.replace('source', 'sourceFix')
        window.location.href = url
      }
    },

    // 查看当前订单
    _viewCurrentOrder() {
      let TravelingCarOrder = this.unImportantInitInfo.TravelingCarOrder || {}
      let Id = this.unImportantInitInfo.TravelingCarOrder.Id
      let IsShowPay = TravelingCarOrder.PageBtnInfo ? TravelingCarOrder.PageBtnInfo.IsShowPay : false
      let PayOperationType = TravelingCarOrder.PageBtnInfo ? TravelingCarOrder.PageBtnInfo.PayOperationType : ''
      let PathJumpType = TravelingCarOrder.PageBtnInfo ? TravelingCarOrder.PageBtnInfo.PathJumpType : ''
      let IsShowPath = TravelingCarOrder.PageBtnInfo ? TravelingCarOrder.PageBtnInfo.IsShowPath : false
      if (IsShowPay && PayOperationType === 0) { // 跳转滴滴去支付
        if (this.isMiniprogram) {
          this.$toast(this.$t('WeChat_Limit_1'))
          return
        }
        this.$router.push({
          path: '/car/orderSuccess',
          query: {
            OrderNo: Id,
            fixedBackPath: this.$route.fullPath,
            OperationType: 3,
          }
        })
      } else if (IsShowPath && PathJumpType === 0) { // 跳转滴滴行程轨迹
        if (this.isMiniprogram) {
          this.$toast(this.$t('WeChat_Limit_1'))
          return
        }
        this._getJumpUrl(Id)
      } else if (IsShowPath && PathJumpType === 1) { // 跳转恒顺行车轨迹
        this.$router.push({path: '/car/orderDetailsDriving', query: {OrderID: Id, back: 1}})
      } else { // 跳转用车订单详情
        this.$router.push({path: '/car/orderDetails', query: {OrderID: Id, back: 1}})
      }
    },

    // 获取滴滴或者悦行跳转地址
    _getJumpUrl(Id, OperationType) {
      kpiCarGetOperationUrl({
        OperationType: 1,
        OrderId: Id
      }).then(res => {
        // this.jumpUrl = res.ResultData.H5Url
        res.ResultData && res.ResultData.H5Url && this._jumpOrderSuccess({
          OrderNo: Id,
          H5Url: res.ResultData.H5Url
        })
      })
    },

    // 跳转h5详情页
    _jumpOrderSuccess(dCarOrder) {
      this.$router.push({
        path: '/car/orderSuccess',
        query: {
          OrderNo: dCarOrder.OrderNo,
          fixedBackPath: '/home'
          // H5Url: dCarOrder.H5Url
        }
      })
    },

    /*******************************************************************************/

    /** 获取因公的业务数量 */
    _getBusinessCount() {
      let count = 0
      if (this.selectedIndex === 0) {
        this.hasPower('因公:机票') && (count += 1);
        this.hasPower('因公:酒店') && (count += 1);
        this.hasPower('因公:火车票') && (count += 1);
        this.hasPower('因公:用车') && (count += 1);
      } else {
        (this.hasPower('因私:国内机票') || this.hasPower('因私:国际机票')) && (count += 1);
        (this.hasPower('因私:国内酒店') || this.hasPower('因私:国际酒店')) && (count += 1);
        this.hasPower('因私:火车票') && (count += 1);
      }
      return count
    },

    /**
     * 下拉刷新网页
     */
    _reloadWebview(type) {
      let HOME_HELP = window.localStorage.HOME_HELP
      let UNIT = window.localStorage.UNIT
      let UN = window.localStorage.UN
      let language = window.localStorage.language || 'CN'
      let currency = window.localStorage.currency || 0 // 币种缓存
      let CurrencyInfo = window.localStorage.CurrencyInfo || JSON.stringify(DEFAULT_CURRENCY_INFO) // 币种缓存
      let FollowTheSystemLanguage = window.localStorage.FollowTheSystemLanguage
      let HomsomFAFKLDIGLDA = window.localStorage.HomsomFAFKLDIGLDA
      // 查询页 机票火车票行程历史 版本更新时保留
      let HISTORY_TRIP_PLANE_CITY = window.localStorage.HISTORY_TRIP_PLANE_CITY
      let HISTORY_TRIP_TRAIN_CITY = window.localStorage.HISTORY_TRIP_TRAIN_CITY
      let HomsomLoginType = window.localStorage.HomsomLoginType

      window.localStorage.clear()

      HISTORY_TRIP_PLANE_CITY && (window.localStorage.HISTORY_TRIP_PLANE_CITY = HISTORY_TRIP_PLANE_CITY)
      HISTORY_TRIP_TRAIN_CITY && (window.localStorage.HISTORY_TRIP_TRAIN_CITY = HISTORY_TRIP_TRAIN_CITY)

      window.localStorage.HOME_HELP = HOME_HELP
      window.localStorage.UNIT = UNIT
      window.localStorage.UN = UN
      // 语言重新赋值
      window.localStorage.language = language
      if (FollowTheSystemLanguage) {
        window.localStorage.FollowTheSystemLanguage = FollowTheSystemLanguage
      }
      window.localStorage.HomsomFAFKLDIGLDA = HomsomFAFKLDIGLDA
      window.localStorage.currency = currency // 添加本地币种缓存
      window.localStorage.CurrencyInfo = CurrencyInfo // 添加本地币种缓存
      setHomsomLoginType(HomsomLoginType || '') // 详细备注 wap.homsom.com/README.md RemarksCode 202411290001
      window.location.reload()
    },

    /** 初始化selectedIndex */
    _initPersonalPower() {
      if (this.PersonalPower) {
        if (this.hasPower('因公')) {
          this.selectedIndex = 0
        } else if (this.hasPower('因私')) {
          this.selectedIndex = 1
        }
      }
    },

    /**
     * 切换tab
     */
    _selectTab(val) {
      this.selectedIndex = val
    },

    /** 分发跳转对应的落地页 */
    _gotoPage(type) {
      const jump = {
        plane: this._gotoPlaneTicketQuery,
        hotel: this._gotoHotelQuery,
        train: this._gotoTrainTicketQuery,
        car: this._gotoCarQuery,
        dinner: this._gotoDinnerQuery,
        travel: this._gotoTravelForm,
        travelApply: this._gotoTravelApply
      }
      if (jump[type]) {
        jump[type]()
      }
    },

    /**
     * 去机票查询页面
     */
    _gotoPlaneTicketQuery() {
      planeRoutePush({path: '/planeTicket/query', query: {TravelType: this.selectedIndex, back: 1}})
    },
    /**
     * 去酒店查询页面
     */
    _gotoHotelQuery() {
      hotelRoutePush(getRoutePath({
        path: '/hotel/query',
        query: {
          TravelType: this.selectedIndex
        }
      }))
    },
    /**
     * 去火车票查询页面
     */
    _gotoTrainTicketQuery() {
      trainRoutePush({path: '/train/query', query: {TravelType: this.selectedIndex, back: 1}})
    },
    /**
     * 跳转用车查询页
     * */
    _gotoCarQuery() {
      this.$router.push({path: '/car/query', query: {TravelType: this.selectedIndex}})
    },

    // 跳转用餐页面
    _gotoDinnerQuery() {
      kpiAccessGetFoodAddress({
        TravelType: this.selectedIndex
      }).then(res => {
        if (res.IsSuccess) {
          window.location.href = res.ResultData.AccessUrl
        }
      })
    },

    // 跳转汽车票query查询页
    _gotoBusQuery() {
      this.$router.push({path: '/bus/query', query: {TravelType: this.selectedIndex}})
    },

    /**
     * 跳转旅游会务表单页
     * */
    _gotoTravelForm() {
      let PersonalPower = this.PersonalPower
      if (
        PersonalPower.BusinessPermission &&
        PersonalPower.BusinessPermission.TravelConferencePermission &&
        PersonalPower.BusinessPermission.TravelConferencePermission.Url
      ) {
        window.location.href = PersonalPower.BusinessPermission.TravelConferencePermission.Url
      }
    },

    // 跳转出差申请单
    _gotoTravelApply() {
      this.$router.push('/travelApply/bookDetails')
    },

    // 申请单跳转业务下单
    _goToOaBooking(item) {
      let OrderBusinessType = item.OrderBusinessType
      let Code = item.Code
      if (OrderBusinessType === 1) { // 国内机票
        this._gotoFlightBooking(Code)
      } else if (OrderBusinessType === 6) { // 国际机票
        this._gotoIntlFlightBooking(Code)
      } else if (OrderBusinessType === 2) { // 国内酒店
        this._gotoHotelBooking(Code)
      } else if (OrderBusinessType === 11) { // 海外酒店
        this._gotoIntlHotelBooking(Code)
      } else if (OrderBusinessType === 10) { // 火车票
        this._gotoTrainBooking(Code)
      } else if (OrderBusinessType === 14) { // 用车
        this._gotoCarBooking(Code, item.ApplyType)
      } else if (OrderBusinessType === 17) { // 国际机票需求单
        this._gotoInquirySheetBooking(Code)
      }
    },

    /** 预订 */
    _gotoFlightBooking(Code) {
      if (!this.hasPower('因公:机票')) {
        this._showTips()
        return false
      }
      planeRoutePush({
        path: '/planeTicket/query',
        query: {
          TravelType: 0,
          AuthorizationCode: Code,
          OrderBusinessType: 1,
          back: 1
        }
      })
    },

    _gotoIntlFlightBooking(Code) {
      if (!this.hasPower('因公:机票')) {
        this._showTips()
        return false
      }
      planeRoutePush({
        path: '/planeTicket/query',
        query: {
          TravelType: 0,
          AuthorizationCode: Code,
          OrderBusinessType: 6,
          back: 1
        }
      })
    },

    _gotoHotelBooking(Code) {
      if (!this.hasPower('因公:酒店')) {
        this._showTips()
        return false
      }
      hotelRoutePush(getRoutePath({
        path: '/hotel/query',
        query: {
          TravelType: 0,
          AuthorizationCode: Code,
          OrderBusinessType: 2,
          fixedBackPath: 'home'
        }
      }))
    },

    _gotoIntlHotelBooking(Code) {
      if (!this.hasPower('因公:酒店')) {
        this._showTips()
        return false
      }
      hotelRoutePush(getRoutePath({
        path: '/hotel/query',
        query: {
          TravelType: 0,
          AuthorizationCode: Code,
          OrderBusinessType: 11,
          fixedBackPath: 'home'
        }
      }))
    },

    _gotoTrainBooking(Code) {
      if (!this.hasPower('因公:火车票')) {
        this._showTips()
        return false
      }
      this.$router.push({
        path: '/train/query',
        query: {
          TravelType: 0,
          AuthorizationCode: Code,
          fixedBackPath: 'home'
        }
      })
    },

    _gotoCarBooking(Code, ApplyType) {
      if (!this.hasPower('因公:用车')) {
        this._showTips()
        return false
      }
      this.$router.push({
        path: '/car/query',
        query: {
          ApplyType: ApplyType,
          TravelType: 0,
          AuthorizationCode: Code,
          fixedBackPath: 'home'
        }
      })
    },

    _gotoInquirySheetBooking(Code) {
      this.$router.push({
        path: '/intlPlaneTicket/inquirySheet',
        query: {
          TravelType: 0,
          AuthorizationCode: Code,
          fixedBackPath: 'home'
        }
      })
    },

    /** 滚动监听 */
    _mixinScroll(pos) {
      if (pos.y <= -1) {
        this.showFixedHeader = true
      } else if (pos.y > 0 ) {
        this.showFixedHeader = false
      }
    }
  },
  components: {
    CurrentOrder: () => import('pages/car/query/current-order'),
    HomeAuthList,
    HomeBanner,
    HomeBusinessEntry,
    HsTab4,
    HomeWelcomeCard,
    HomeBusinessCard,
    SelectBusinessBook,
    CFrame,
    HsScroll,
    CTabbar
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
.hs-container
  width 100%
  height 100%
  background linear-gradient(180deg, #F9F8F8 0%, #F2F1F1 100%)
  >.table-view
    width 100%
    height calc(100% - 56px)
    overflow hidden
    .scroll-content
      padding 0 12px 50px 12px
  >.header-box
    position absolute
    top 0
    left 0
    width 100%
    padding 0 12px
    background-color $color_black_0
    z-index 1
  .home-announcement{
    @extend .flex-start;
    width: 100%;
    margin-bottom: 12px;
    border-radius 12px;
    background-color: $color_black_0;
    position: relative;
    >.bar{
      width: 100%;
      padding: 12px;
      .news{
        @extend .flex-start;
        width: 100%;
        height: 20px;
        >span{
          @extend .hs-font-body;
          ellipsis(1);
          width: 100%;
          height: 20px;
          color: $color_black_800;
        }
        .announcement-icon{
          position: relative;
          pointer-events: auto;
          flex-shrink: 0;
          opacity: 0;
          padding: 0 12px 0 0;
        }
      }
    }
    .announcement-icon{
      @extend .flex-end;
      @extend .hs-font-caption-1;
      position: absolute;
      top: 0;
      right: 0;
      line-height: 20px;
      color: $color_orange_300;
      flex-shrink: 0;
      padding: 12px 12px 12px 0;
      pointer-events: none;
      >img{
        flex-shrink: 0;
        width: 12px;
        height: 12px;
      }
    }
  }
  .travel-form
    width 100%
    height calc(22.8vw - 5.5px)
    border-radius 12px
    background-size 100% 100%
    background-repeat no-repeat
    margin-bottom 12px
  >.getVersion
    @extend .disabled
    width 0
    height 0
    opacity 0
</style>
